import { getAvailableTags } from '.'
import { ActionCardData } from './types'

// Detects master conditional tags changes (in assessment responses) and returns the current tag names
const getActiveTagNames = (clonedState: ActionCardData) => {
  const availableTags = getAvailableTags(clonedState.sections)

  const tags: string[] = []

  clonedState.conditionalItems.map(tagId => {
    const tagName = availableTags[tagId]

    if (tagName) {
      tags.push(tagName)
    }
  })

  return tags
}

export default getActiveTagNames
